import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-preview-pdf-dialog',
  //standalone: true,
  //imports: [],
  templateUrl: './preview-pdf-dialog.component.html',
  styleUrl: './preview-pdf-dialog.component.scss'
})
export class PreviewPdfDialogComponent {

  loadingModal: boolean = false
  selectedPreviewUrl

  constructor( 
    @Inject(MAT_DIALOG_DATA) 
    public data, private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<PreviewPdfDialogComponent>) {
      console.log(data)
        this.selectedPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.selectedPreviewUrl)
        console.log(data.selectedPreviewUrl)
  }
  
  ngOnInit() { }

  // Cierras el modal con el event 2 para que el padre sepa que no se puede enviar al back la data
  closeDialog() {
    this.dialogRef.close({event: 2});
  }
  // Cierras el modal con el event 1 para que el padre sepa que se puede enviar al back la data
  save(){
    this.loadingModal = true
    this.dialogRef.close({event: 1});
  }

  closePreview(){
    this.dialogRef.close({event: 1});
  }

}